document.addEventListener('DOMContentLoaded', function () {
  // --- DOM Elements ---
  const faqContainer = document.querySelector('.fem-faq-container');
  if (!faqContainer) return; // Exit if not on the FAQ page

  const searchInput = faqContainer.querySelector('.fem-faq-search-input');
  const searchClear = faqContainer.querySelector('.fem-faq-search-clear');
  const emptyState = faqContainer.querySelector('.fem-faq-empty-state');
  const cards = faqContainer.querySelectorAll('.fem-faq-card');
  const headers = faqContainer.querySelectorAll('.fem-faq-card-header');
  const sections = faqContainer.querySelectorAll('.fem-faq-section');
  const navBtns = faqContainer.querySelectorAll('.fem-faq-nav-btn');
  const navList = faqContainer.querySelector('.fem-faq-nav-list');

  // --- Accordion Logic ---
  headers.forEach(header => {
    header.addEventListener('click', function (e) {
      e.preventDefault();
      const card = this.parentElement;
      const body = card.querySelector('.fem-faq-card-body');
      
      const isActive = card.classList.contains('active');
      
      // Close other cards in the same section for cleaner UX
      const section = card.closest('.fem-faq-section');
      if (section) {
        section.querySelectorAll('.fem-faq-card.active').forEach(activeCard => {
          if (activeCard !== card) {
            activeCard.classList.remove('active');
            activeCard.querySelector('.fem-faq-card-body').style.maxHeight = '0';
          }
        });
      }

      if (isActive) {
        card.classList.remove('active');
        body.style.maxHeight = '0';
      } else {
        card.classList.add('active');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // Keep accordion heights updated on window resize (since scrollHeight changes with fluid widths)
  window.addEventListener('resize', debounce(() => {
    cards.forEach(card => {
      if (card.classList.contains('active')) {
        const body = card.querySelector('.fem-faq-card-body');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  }, 150));

  // --- Search Logic ---
  // Store original HTML contents to cleanly remove highlights on search clear
  const originalTexts = new Map();
  cards.forEach(card => {
    const qEl = card.querySelector('.fem-faq-question-text');
    const aEl = card.querySelector('.fem-faq-card-body-content p');
    originalTexts.set(card, {
      questionHTML: qEl.innerHTML,
      questionText: qEl.textContent.trim().toLowerCase(),
      answerHTML: aEl.innerHTML,
      answerText: aEl.textContent.trim().toLowerCase()
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const query = this.value.trim().toLowerCase();
      
      // Toggle clear button
      if (query.length > 0) {
        searchClear.classList.add('visible');
      } else {
        searchClear.classList.remove('visible');
      }

      filterFAQs(query);
    });

    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      this.classList.remove('visible');
      filterFAQs('');
      searchInput.focus();
    });
  }

  function filterFAQs(query) {
    let visibleCardsTotal = 0;

    sections.forEach(section => {
      let visibleCardsInSection = 0;
      const sectionCards = section.querySelectorAll('.fem-faq-card');

      sectionCards.forEach(card => {
        const qEl = card.querySelector('.fem-faq-question-text');
        const aEl = card.querySelector('.fem-faq-card-body-content p');
        const orig = originalTexts.get(card);

        if (!query) {
          // Reset original texts and show cards
          qEl.innerHTML = orig.questionHTML;
          aEl.innerHTML = orig.answerHTML;
          card.style.display = 'block';
          visibleCardsInSection++;
          return;
        }

        const matchQuestion = orig.questionText.includes(query);
        const matchAnswer = orig.answerText.includes(query);

        if (matchQuestion || matchAnswer) {
          card.style.display = 'block';
          visibleCardsInSection++;

          // Highlight text matching the query
          highlightText(qEl, orig.questionHTML, query);
          highlightText(aEl, orig.answerHTML, query);

          // Auto-expand card if match is inside the answer text
          const body = card.querySelector('.fem-faq-card-body');
          if (matchAnswer && !card.classList.contains('active')) {
            card.classList.add('active');
            body.style.maxHeight = body.scrollHeight + 'px';
          }
        } else {
          card.style.display = 'none';
          // Collapse hidden cards
          card.classList.remove('active');
          card.querySelector('.fem-faq-card-body').style.maxHeight = '0';
        }
      });

      // Show/hide section based on matches
      if (visibleCardsInSection > 0) {
        section.style.display = 'block';
        visibleCardsTotal += visibleCardsInSection;
      } else {
        section.style.display = 'none';
      }

      // Sync active state of navigation pills
      updateNavVisibility(query);
    });

    // Toggle empty state message
    if (visibleCardsTotal === 0 && query !== '') {
      emptyState.classList.add('visible');
    } else {
      emptyState.classList.remove('visible');
    }
  }

  function highlightText(element, originalHTML, query) {
    // Basic regex replacement for highlighting
    // Matches text ignoring HTML tags
    if (!query) {
      element.innerHTML = originalHTML;
      return;
    }

    // Strip HTML tags for clean matching text segments
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = originalHTML;
    const text = tempDiv.textContent;

    const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
    if (regex.test(text)) {
      // Simple text replacement is safest for plain-text FAQ contents
      // Here we assume FAQ questions and answers contain minimal inline HTML formatting
      const safeText = escapeHTML(text);
      element.innerHTML = safeText.replace(regex, '<span class="fem-faq-highlight">$1</span>');
    } else {
      element.innerHTML = originalHTML;
    }
  }

  function updateNavVisibility(query) {
    // Hide navigation items for categories that have no matches
    navBtns.forEach(btn => {
      const targetId = btn.getAttribute('data-target');
      const targetSection = document.getElementById(targetId);
      const navItem = btn.parentElement;

      if (targetSection && targetSection.style.display === 'none') {
        navItem.style.display = 'none';
      } else {
        navItem.style.display = 'block';
      }
    });
  }

  // --- Category Sticky Scroll & Scrollspy ---
  navBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        // Disable scrollspy temporarily to prevent jitter
        window.removeEventListener('scroll', scrollspyHandler);

        // Highlight clicked nav
        navBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        // Scroll to target section
        const yOffset = -20; // Additional offset for design spacing
        if (window.innerWidth <= 768) {
          // Mobile sticky header offset
          const sidebarHeight = document.querySelector('.fem-faq-sidebar').offsetHeight || 60;
          const y = targetSection.getBoundingClientRect().top + window.scrollY - sidebarHeight - 10;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }

        // Center mobile nav tab if scrolled
        if (window.innerWidth <= 768) {
          centerMobileTab(this);
        }

        // Re-enable scrollspy after scroll finishes
        setTimeout(() => {
          window.addEventListener('scroll', scrollspyHandler);
        }, 800);
      }
    });
  });

  function scrollspyHandler() {
    let currentSection = '';
    const scrollPos = window.scrollY + (window.innerWidth <= 768 ? 100 : 80);

    sections.forEach(section => {
      if (section.style.display !== 'none') {
        const top = section.offsetTop;
        const height = section.offsetHeight;
        if (scrollPos >= top && scrollPos < top + height) {
          currentSection = section.getAttribute('id');
        }
      }
    });

    if (currentSection) {
      navBtns.forEach(btn => {
        const target = btn.getAttribute('data-target');
        if (target === currentSection) {
          if (!btn.classList.contains('active')) {
            btn.classList.add('active');
            if (window.innerWidth <= 768) {
              centerMobileTab(btn);
            }
          }
        } else {
          btn.classList.remove('active');
        }
      });
    }
  }

  function centerMobileTab(activeBtn) {
    if (!navList || !activeBtn) return;
    const navListWidth = navList.offsetWidth;
    const btnLeft = activeBtn.offsetLeft;
    const btnWidth = activeBtn.offsetWidth;
    
    // Scroll active button to the center of the viewport
    navList.scrollTo({
      left: btnLeft - (navListWidth / 2) + (btnWidth / 2),
      behavior: 'smooth'
    });
  }

  // Bind scrollspy
  window.addEventListener('scroll', scrollspyHandler);

  // --- Helper Functions ---
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  function escapeHTML(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});
